var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTurno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    d: "M59.994 60H20V25h39.994V60ZM65 63.75V21.25c0-.687-.563-1.25-1.25-1.25H16.25C15.563 20 15 20.563 15 21.25V63.75c0 .687.563 1.25 1.25 1.25h47.493c.687 0 1.25-.563 1.25-1.25M30 15h-5v15h5V15ZM65 37.5H15v5h50v-5ZM42.5 15h-5v15h5V15ZM55 15h-5v15h5V15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTurno);
export default __webpack_public_path__ + "static/media/Turno.7c8e934636a5454c5f3bc416ce74af3b.svg";
export { ForwardRef as ReactComponent };